module.exports = __webpack_public_path__ + "static/media/fabric_canvas.89eb6ebb.svg";